import { createBrowserRouter, Navigate } from 'react-router-dom';
import { AuthProvider } from './auth/AuthContext.jsx';
import { RequireAuth } from './auth/RequireAuth.jsx';
import { AppShell } from './components/layout/AppShell.jsx';
import { Login } from './pages/Login.jsx';
import { InviteAccept } from './pages/InviteAccept.jsx';
import { Dashboard } from './pages/Dashboard.jsx';
import { CarsList } from './pages/CarsList.jsx';
import { CarDetail } from './pages/CarDetail.jsx';
import { CarForm } from './pages/CarForm.jsx';
import { Alerts } from './pages/Alerts.jsx';
import { Account } from './pages/Account.jsx';
import { Users } from './pages/Users.jsx';
import { PublicSign } from './pages/PublicSign.jsx';

function Root({ children }) {
  return <AuthProvider>{children}</AuthProvider>;
}

export const router = createBrowserRouter([
  { path: '/login', element: <Root><Login /></Root> },
  { path: '/invite', element: <Root><InviteAccept /></Root> },
  { path: '/invite/:token', element: <Root><InviteAccept /></Root> },
  { path: '/sign/:token', element: <PublicSign /> },
  {
    path: '/',
    element: (
      <Root>
        <RequireAuth>
          <AppShell />
        </RequireAuth>
      </Root>
    ),
    children: [
      { index: true, element: <Dashboard /> },
      { path: 'cars', element: <CarsList /> },
      { path: 'cars/new', element: <CarForm /> },
      { path: 'cars/:id', element: <CarDetail /> },
      { path: 'cars/:id/edit', element: <CarForm /> },
      { path: 'alerts', element: <Alerts /> },
      { path: 'account', element: <Account /> },
      { path: 'users', element: <Users /> },
    ],
  },
  { path: '*', element: <Navigate to="/" replace /> },
]);
